module.exports = __webpack_public_path__ + "static/media/upload_media.c5c1731f.svg";